// @ts-nocheck

import styled from 'styled-components';

import { SportsArrow } from '../../assets/svg/sports-menu';

const ExpandArrow = styled(SportsArrow)`
  transition: all 200ms ease-in-out;
  transform: ${({ $isExpanded }) => ($isExpanded ? 'rotate(0deg)' : 'rotate(180deg)')};
`;

export default ExpandArrow;
